import { UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from '../../services/selection-generic.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MoreFilterPopupComponent } from './more-filter-popup/more-filter-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { FilterService } from '../../services/filter.service';
import { FileExportService } from '../../services/file-export.service';
import { EmployeeSelectionFilters } from '../../entities/employee-search-modal';
import { LeaveSelectionFilters } from '../../entities/leave-search-modal';
import { MatTableDataSource } from '@angular/material/table';
import { TaskSelectionFilters } from '../../entities/task-search-modal';
import { TaskTrasferPopupComponent } from '../popups/task-trasfer-popup/task-trasfer-popup.component';
import { TaskTransferTypes } from 'app/modules/common/enums/task-transfer-types';
import { ActuationSelectionFilter } from '../../entities/actutaion-selection-modal';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { LeaveReportPopupComponent } from '../popups/leave-report-popup/leave-report-popup.component';
import { TasksChangePopupComponent } from '../popups/tasks-change-popup/tasks-change-popup.component';
import { DownloadableDocument } from 'app/modules/common/entities/dropdown/downloadable-document.model';

@Component({
    selector: 'app-main-filters',
    templateUrl: './main-filters.component.html',
    styleUrls: ['./main-filters.component.scss'],
    standalone: false
})
export class MainFiltersComponent implements OnInit {
    TaskTransferTypes = TaskTransferTypes;
    public employeeFilter = new UntypedFormControl('',Validators.minLength(4));
    constructor(
        public selectionService: SelectionGenericService,
        public sharedService: SharedService,
        public dialog: MatDialog,
        private empresaTreeViewService: EmpresaTreeViewService,
        public filterService: FilterService,
        public fileExportService: FileExportService,
        private pageLoaderService: PageLoaderService
    ) {
        // NEED TO UPDATE SELECTED COMPANY WHEN EMMIT IS CALLED
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
                this.selectionService.selectedCompanyId = _res;
                this.filterService.clearEmployeeMoreFilters();
                this.filterService.clearLeaveMoreFilters();
            }
        });
    }

    ngOnInit(): any {
        this.selectionService.setPermissionForContextMenu();
        this.ResetListAndLeavePanel();
        // These Two Selections can be Loaded as the Defualt Ones, Reason -> Once Logged Out the Changes are not Gone
        this.selectionService.leaveSelectionModal = new LeaveSelectionFilters();
        this.selectionService.taskSelectionModal = new TaskSelectionFilters();
    }

    SelectionTabChange(event: any): any {
        switch (event.tab.textLabel) {
            case 'Trabajadores':
                this.sharedService.selectedSelectionTabId = 1;
                this.selectionService.isShowLeavePanel = false                
                this.selectionService.employeeSelectionModal =
                    new EmployeeSelectionFilters();
                    this.selectionService.employeeFilter=this.employeeFilter;
                break;

            case 'Bajas':
                this.sharedService.selectedSelectionTabId = 2;
                this.selectionService.isShowLeavePanel = false
                this.selectionService.leaveSelectionModal =
                    new LeaveSelectionFilters();
                    this.selectionService.employeeFilter=this.employeeFilter;
                break;

            case 'Actuaciones':
                this.sharedService.selectedSelectionTabId = 3;
                this.selectionService.isShowLeavePanel = false
                this.selectionService.ActuationSelectionModal =
                    new ActuationSelectionFilter();
                break;

            case 'Tareas':
                this.sharedService.selectedSelectionTabId = 5;
                this.selectionService.isShowLeavePanel = false
                this.selectionService.taskSelectionModal =
                    new TaskSelectionFilters();
                break;

            default:
                break;
        }
        this.ResetListAndLeavePanel();
        this.selectionService.hideRecordingsPanel();
    }

    ResetListAndLeavePanel(): void {
        // To Reset Result List & Leave Panel
        this.selectionService.dataSource = new MatTableDataSource();
        this.selectionService.rowDataForLeaveReport.emit(false);
    }

    public excecuteQueryForSearch(): any {
        switch (this.sharedService.selectedSelectionTabId) {
            case 1:
                if(this.selectionService.employeeFilter.errors==null)
                {
                    // First Page with Fifty Records (0, 50)
                    this.selectionService.SearchEmployees(0, 10, true);
                }
               
                break;

            case 2:
                if(this.selectionService.employeeFilter.errors==null)
                {
                    // First Page with Fifty Records (0, 50)
                    this.selectionService.SearchLeaves(0, 10, true);
                }
                
                break;

            case 3:
                if(this.selectionService.employeeFilter.errors==null)
                {
                    // First Page with Fifty Records (0, 50)
                    this.selectionService.GetActuationSelection(0, 10, true);
                }
                // First Page with Fifty Records (0, 50)
                
                break;

            case 5:
                // First Page with Fifty Records (0, 50)
                this.selectionService.SearchTasks(0, 10, true);
                break;

            default:
                this.selectionService.ShowSnackBar(
                    'Actualmente no implementado',
                    'Okay',
                    2500
                );
                break;
        }
    }

    SelectTabforSearch(id: number): any {
        this.sharedService.selectedSelectionTabId = id;
    }

    public openMoreFilterPopup(): any {
        let width = '';
        switch (this.sharedService.selectedSelectionTabId) {
            case 1:
                width = '400px';
                break;

            case 2:
                width = '700px';
                break;
            case 3:
                width = '1010px';
                break;

            case 5:
                width = '500px';
                break;

            default:
                width = '';
                break;
        }

        if (width !== '') {
            this.dialog.open(MoreFilterPopupComponent, {
                width: width,
            });
        } else {
            this.sharedService.ShowSnackBar(
                'Actualmente no implementado',
                'Okay',
                2000
            );
        }
    }

    public generateExcelFile(): void {
        this.pageLoaderService.ShowPageLoader();
        this.selectionService.GetSelectionExcel().subscribe(
            (res) => {
                if (res.code === 0) {
                    const file = res.result as DownloadableDocument;
                    this.fileExportService.DownloadDoc(file);
                } else if (res.code === 2) {
                    this.sharedService.ShowSnackBar(
                        'El archivo tenía demasiados registros, se enviará un correo electrónico con el resultado establecido en su dirección de correo electrónico.',
                        'Okay',
                        2000
                    );
                } else if (res.code === 3) {
                    this.sharedService.ShowSnackBar(
                        'el archivo tenía demasiados datos, no se puede enviar un correo electrónico con el archivo de resultados porque el usuario no ' +
                            'tiene una dirección de correo electrónico definida',
                        'Okay',
                        2000
                    );
                } else if (res.code === 1) {
                    this.sharedService.ShowSnackBar(
                        'Lo siento, la generación del archivo Excel ha fallado',
                        'Okay',
                        2000
                    );
                } else {
                    this.sharedService.ShowSnackBar(
                        'La lista esta vacía',
                        'Okay',
                        2000
                    );
                }

                this.pageLoaderService.HidePageLoader();
            },
            (error) => {
                console.error(error);
                this.sharedService.ShowSnackBar(
                    'La lista esta vacía',
                    'Okay',
                    2000
                );
                this.pageLoaderService.HidePageLoader();
            }
        );
    }

    OpenTaskTransferPopup(Type: TaskTransferTypes): void {
        if (this.selectionService.dataSource.data.length > 0) {
            const modalRef = this.dialog.open(TaskTrasferPopupComponent, {
                width: '400px',
            });
            modalRef.componentInstance.TransferType = Type;
        } else {
            this.sharedService.ShowSnackBar(
                'Por favor seleccione tareas antes de transferir',
                'okay',
                2000
            );
        }
    }

    ShowLeaveReportPopup(): void {
        const dialogRef = this.dialog.open(LeaveReportPopupComponent);
        dialogRef.afterClosed().subscribe((res) => {
            // Do whats needed to be done after the popup closes
        });
    }

    /**
     * Show task change popup
     */
    ShowTaskChangePopup(): void {
        this.dialog.open(TasksChangePopupComponent);
    }
}
